import React, { createContext, useContext, useMemo, useState } from 'react';
import { ContentItem } from '../../../models/ContentManagementInterface';

interface BlockPaletteDragValue {
  /** The block type currently being dragged from the palette, or null. */
  draggingType: ContentItem['type'] | null;
  startDrag: (type: ContentItem['type']) => void;
  endDrag: () => void;
}

const BlockPaletteDragContext = createContext<BlockPaletteDragValue>({
  draggingType: null,
  startDrag: () => {},
  endDrag: () => {},
});

/**
 * Shares "a palette block is being dragged" across the v2 editor so the insert
 * slots between blocks can reveal themselves as drop zones only while a drag is
 * in progress.
 */
export function BlockPaletteDragProvider({ children }: { children: React.ReactNode }) {
  const [draggingType, setDraggingType] = useState<ContentItem['type'] | null>(null);
  const value = useMemo<BlockPaletteDragValue>(
    () => ({
      draggingType,
      startDrag: (type) => setDraggingType(type),
      endDrag: () => setDraggingType(null),
    }),
    [draggingType],
  );
  return (
    <BlockPaletteDragContext.Provider value={value}>{children}</BlockPaletteDragContext.Provider>
  );
}

export function useBlockPaletteDrag(): BlockPaletteDragValue {
  return useContext(BlockPaletteDragContext);
}
